import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3579f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  class: "w-100 card no-border background-fb",
  style: {"height":"100%","padding-left":"3px"}
}
const _hoisted_4 = { class: "card-header popper-header" }
const _hoisted_5 = {
  class: "nav nav-func-header",
  style: {"border-bottom":"1px black solid"}
}
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "d-flex flex-column full-width margin-top-10" }
const _hoisted_10 = { class: "input-div" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["id", "onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1))
const _hoisted_14 = { class: "description-text" }
const _hoisted_15 = { class: "description-header" }
const _hoisted_16 = { class: "description-body" }
const _hoisted_17 = {
  class: "card no-border background-fb w-100",
  style: {"min-height":"300px"}
}
const _hoisted_18 = { class: "card-header popper-header" }
const _hoisted_19 = {
  class: "nav nav-func-header",
  style: {"border-bottom":"1px black solid"}
}
const _hoisted_20 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_21 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_22 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_23 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_24 = {
  class: "card-body font-size-14",
  style: {"z-index":"5000","overflow":"auto"}
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "d-flex flex-column" }
const _hoisted_27 = { style: {"float":"left"} }
const _hoisted_28 = ["src"]
const _hoisted_29 = { style: {"float":"left"} }
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = ["src"]
const _hoisted_33 = { id: "main-screen" }
const _hoisted_34 = { class: "loader-div-sm" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "line-break margin-bottom-10" }
const _hoisted_39 = {
  key: 0,
  class: "line-break margin-top-10 margin-bottom-10"
}
const _hoisted_40 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "line-break margin-top-10 margin-bottom-10"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Text")
], -1))
const _hoisted_44 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Math")
], -1))
const _hoisted_47 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date")
], -1))
const _hoisted_50 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Logic")
], -1))
const _hoisted_53 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Encode/Decode")
], -1))
const _hoisted_56 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Array")
], -1))
const _hoisted_59 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "General")
], -1))
const _hoisted_62 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Special Values")
], -1))
const _hoisted_65 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Expression Type")
], -1))
const _hoisted_69 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Function Operation Type")
], -1))
const _hoisted_71 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Function Type")
], -1))
const _hoisted_73 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = { class: "line-break margin-top-10 margin-bottom-10" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "System Variables", -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = {
  key: 2,
  class: "line-break margin-top-10 margin-bottom-10"
}
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { key: 3 }
const _hoisted_82 = { class: "d-flex flex-column" }
const _hoisted_83 = { style: {"float":"left"} }
const _hoisted_84 = ["src"]
const _hoisted_85 = ["src"]
const _hoisted_86 = ["src"]
const _hoisted_87 = { id: "main-screen" }
const _hoisted_88 = { class: "loader-div-sm" }
const _hoisted_89 = ["src"]

import {
  computed,
  inject,
  nextTick,
  onBeforeMount,
  onMounted,
  ref,
  watch,
} from "vue";
import {
  ElScrollbar,
  ElSelect,
  ElOption,
  ElTooltip,
  ElDivider,
  ElInput,
  ElTag,
} from "element-plus";
import { searchExpressionByName } from "@/flow/services/flow.service";
import { useStepDisplay } from "@/core/composables/useStepDisplay";
import { useDebouncedSearch } from "@/core/composables/useDebouncedSearch";
import { useLatestRequestGuard } from "@/core/composables/useLatestRequestGuard";
import Drawer from "@/core/json-forms/components/Drawer.vue";
import TagDisplayText from "@/core/json-forms/components/TagDisplayText";
import JsonTreeView from "@/flow/components/json-tree-view/JsonTreeView.vue";
import { DEFAULT_LOGO, ASSETS_BASE_URL, getResolution } from "@/core/logo";
import i18n from "@/core/i18n/i18n";
import { labelConvert } from "@/core/util/variable-label-convert";
import { parseOutputValue } from "@/core/json-forms/functionSelectorUtils";
import {
  normalizeMetaoutputReference,
  normalizeOutputReference,
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
} from "@/flow/utils/outputReferenceUtils";
import { isStepSkipped } from "@/flow/utils/skipUtils";
import {
  createHTMLSpanElement,
  getCaretPosition,
  getType,
  setTagDisplayText,
  setCaretPosition,
  saveCaretPosition,
  ensureCaretRestored,
  hasChild,
} from "./service";

interface Props {
  outputList?: [];
  oldPath?: string;
  idPrefix?: string;
  visible: boolean;
  mode: string;
  clickAbleDataType?: string;
  drawerKey?: string;
  userDefinedVariables?: any;
  showOtherInputs?: boolean;
  showMeta?: boolean;
  systemVariables?: any;
  expressions?: any;
  showExpInfo?: boolean;
  stepIdx?: number;
  functionName?: string;
  selectedVariables?: [];
  metaoutputList?: [];
  disableSkippedStepOutputs?: boolean;
}

type OutputOptionType = "output" | "metaoutput";


export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionSelector',
  props: {
    outputList: {},
    oldPath: {},
    idPrefix: {},
    visible: { type: Boolean },
    mode: {},
    clickAbleDataType: { default: "normal" },
    drawerKey: { default: "drawer-1" },
    userDefinedVariables: {},
    showOtherInputs: { type: Boolean },
    showMeta: { type: Boolean },
    systemVariables: {},
    expressions: {},
    showExpInfo: { type: Boolean },
    stepIdx: {},
    functionName: {},
    selectedVariables: {},
    metaoutputList: {},
    disableSkippedStepOutputs: { type: Boolean }
  },
  emits: [
  "add-output",
  "add-function",
  "add-user-variable",
  "add-system-variable",
  "change-function-visible",
  "add-text",
  "add-metaoutput",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = i18n.global;
const { getStepDisplayNumber } = useStepDisplay();
const preferOrigIdOutputReferences = inject(
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
  true
);

const expressionTypes = ref([
  {
    name: "LOOP",
    hasChild: false,
    type: "expressionType",
  },
  {
    name: "SPLIT",
    hasChild: false,
    type: "expressionType",
  },
  {
    name: "END",
    hasChild: false,
    type: "expressionType",
  },
]);

const translationTypes = ref([
  {
    name: "CSV",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "JSON",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "RSS",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "JAXB",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "Cbor",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "SOAPJAXB",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "AVRO",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "HL7",
    hasChild: false,
    type: "translationType",
  },
  {
    name: "LZF",
    hasChild: false,
    type: "translationType",
  },
]);

const translationOperationTypes = ref([
  {
    name: "MARSHALL",
    hasChild: false,
    type: "translationOperationType",
  },
  {
    name: "UNMARSHALL",
    hasChild: false,
    type: "translationOperationType",
  },
]);

const inputs = ref([]);
const description = ref("");
const scrollbar: any = ref();
const tab = ref(1);
const selectedOutputId = ref();
const selectedMetaoutputId = ref();
const output = ref("");
const metaoutput = ref("");
const keyList = ref([]);
const initValue = ref(0);
const loading = ref(false);
const setValue = ref(0);
const count = ref(0);
const searchQuery = ref("");
const searchResults = ref([]);
const userHasSelectedTab = ref(false);
const userHasSelectedOutput = ref(false);
const selectedOutput: any = computed(() => {
  if (selectedOutputId.value !== undefined) {
    return props.outputList.find(
      (item: any) => item.index === selectedOutputId.value
    );
  }
  return null;
});
const selectedMetaoutput: any = computed(() => {
  if (selectedMetaoutputId.value !== undefined) {
    return props.metaoutputList.find(
      (item: any) => item.index === selectedMetaoutputId.value
    );
  }
  return null;
});
const outputValidityCache = computed(() => {
  const cache = new Map();
  (props.outputList || []).forEach((item: any) => {
    cache.set(item.index, isValidOutput(item, "output"));
  });
  return cache;
});
const metaoutputValidityCache = computed(() => {
  const cache = new Map();
  (props.metaoutputList || []).forEach((item: any) => {
    cache.set(item.index, isValidOutput(item, "metaoutput"));
  });
  return cache;
});
const outputLabels = computed(() => {
  const labels = new Map();
  (props.outputList || []).forEach((item: any) => {
    labels.set(
      item.index,
      `${getStepDisplayNumber(item.index, item.stepNumber)}. Step - ${
        item.connection
      }`
    );
  });
  return labels;
});
const metaoutputLabels = computed(() => {
  const labels = new Map();
  (props.metaoutputList || []).forEach((item: any) => {
    labels.set(
      item.index,
      `${getStepDisplayNumber(item.index, item.stepNumber)}. Step - ${
        item.connection
      }`
    );
  });
  return labels;
});

function isOptionValid(item: any, type: OutputOptionType): boolean {
  const cache =
    type === "output"
      ? outputValidityCache.value
      : metaoutputValidityCache.value;
  return cache.get(item?.index) === true;
}

function isOptionDisabled(item: any): boolean {
  return props.disableSkippedStepOutputs === true && isStepSkipped(item);
}

function isOptionSelectable(item: any, type: OutputOptionType): boolean {
  return Boolean(item) && isOptionValid(item, type) && !isOptionDisabled(item);
}

function getSkippedOptionTooltip(type: OutputOptionType): string {
  return type === "output"
    ? "Skipped step output cannot be selected."
    : "Skipped step metaoutput cannot be selected.";
}

function getOptionClass(item: any, type: OutputOptionType) {
  return {
    "invalid-output": !isOptionValid(item, type),
    "skipped-output": isOptionDisabled(item),
  };
}

const userDefinedVariablesData = computed(() => {
  const formattedObj = {};
  if (props.userDefinedVariables === undefined) return null;

  props.userDefinedVariables.forEach((item) => {
    let value = "";
    try {
      value = JSON.parse(item.value.itemValue);
    } catch (error) {
      value = item.value.itemValue;
    }
    formattedObj[item.value.itemKey] = value;
  });

  return JSON.stringify(formattedObj);
});

const stepIndex = computed(() => {
  if (selectedOutputId.value !== undefined) {
    const data: any = props.outputList.find(
      (item: any) => item.index === selectedOutputId.value
    );
    return data ? data.index : -1;
  }
  return -2;
});
const stepIndexMetaoutput = computed(() => {
  if (selectedMetaoutputId.value !== undefined) {
    const data: any = props.metaoutputList.find(
      (item: any) => item.index === selectedMetaoutputId.value
    );
    return data ? data.index : -1;
  }
  return -2;
});

watch(
  () => selectedOutput.value,
  () => {
    if (selectedOutput.value) {
      output.value = "";
      initValue.value = 0;
      convertToLazyLoad("output");
    }
  }
);
watch(
  () => selectedMetaoutput.value,
  () => {
    if (selectedMetaoutput.value) {
      metaoutput.value = "";
      initValue.value = 0;
      convertToLazyLoad("metaoutput");
    }
  }
);

function changeTab(selectedTab) {
  tab.value = selectedTab;
  userHasSelectedTab.value = true; // User made explicit choice
}

function hasSelectedIndex(index) {
  return index !== undefined && index !== null;
}

function findItemWithIndex(items, index) {
  if (!hasSelectedIndex(index) || !Array.isArray(items)) return null;
  return items.find((item: any) => item.index === index) ?? null;
}

function clearSelectedOutput() {
  selectedOutputId.value = undefined;
  userHasSelectedOutput.value = false;
  output.value = "";
  keyList.value = [];
  initValue.value = 0;
}

function clearSelectedMetaoutput() {
  selectedMetaoutputId.value = undefined;
  metaoutput.value = "";
  keyList.value = [];
  initValue.value = 0;
}

function hasAvailableUserDefinedVariables(): boolean {
  return (
    props.mode === "input" &&
    Array.isArray(props.userDefinedVariables) &&
    props.userDefinedVariables.length > 0
  );
}

function selectDefaultTab() {
  if (props.outputList && props.outputList.length > 0) {
    tab.value = 1;
  } else if (props.showOtherInputs) {
    tab.value = 2;
  } else if (hasAvailableUserDefinedVariables()) {
    tab.value = 4;
  } else {
    tab.value = 2;
  }
}

function convertToLazyLoad(type) {
  if (type === "output" && selectedOutput.value) {
    output.value = parseOutputValue(
      keyList,
      initValue,
      selectedOutput.value.output
    );
  } else if (type === "metaoutput" && selectedMetaoutput.value) {
    metaoutput.value = parseOutputValue(
      keyList,
      initValue,
      selectedMetaoutput.value.metaoutput
    );
  }
  initValue.value += 30;
}

function triggerLazyLoad(event) {
  const mainScreen = document.getElementById("main-screen");
  const distanceToBottom =
    scrollbar.value && mainScreen
      ? event.scrollTop + mainScreen.clientHeight - mainScreen.offsetHeight
      : -1;
  if (distanceToBottom >= 0 && !loading.value) {
    loading.value = true;
    setTimeout(() => {
      addItemToObject();
      loading.value = false;
    }, 1000);
  }
}

const expressionSearchRequestGuard = useLatestRequestGuard();

async function searchExpressions() {
  const requestToken = expressionSearchRequestGuard.start();
  if (searchQuery.value.trim() === "") {
    searchResults.value = [];
    return;
  }
  const result = await searchExpressionByName(searchQuery.value.trim());
  // OT-4928: discard a stale response superseded by a newer search.
  if (!expressionSearchRequestGuard.isLatest(requestToken)) {
    return;
  }
  searchResults.value = result || [];
}

const { onSearchInput } = useDebouncedSearch(searchExpressions, {
  minLength: 0,
});

function addItemToObject() {
  if (selectedOutput.value) {
    try {
      let outputValueString = selectedOutput.value.output;

      // Encapsulating numeric values inside double quotes just for UI representation.
      outputValueString = outputValueString.replace(
        /(?<=:\s|,\s|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
        (match) => `"${match}"`
      );
      outputValueString = outputValueString.replace(
        /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
        (match) => `"${match}"`
      );
      outputValueString = outputValueString.replace(
        /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
        (match) => `"${match}"`
      );

      const json = JSON.parse(outputValueString);
      const copyObject = JSON.parse(output.value.toString());

      keyList.value
        .slice(initValue.value, initValue.value + 15)
        .forEach((key) => {
          copyObject[key] = json[key];
        });

      output.value = JSON.stringify(copyObject);
      initValue.value += 15;
    } catch (error) {
      console.error("JSON parse error in addItemToObject:", error);
      output.value = selectedOutput.value.output;
    }
  }
}

function updatePadding() {
  const element = document.getElementById("step-output-select");
  if (
    element &&
    selectedOutputId.value !== null &&
    selectedOutputId.value !== undefined
  ) {
    element.style.paddingLeft = "43px";
  } else {
    element.style.paddingLeft = "30px";
  }
}

function callAddFunction(data) {
  const params = {
    ...data,
    tooltip: data.description,
    inputId: focusInputId.value >= 0 ? focusInputId.value : undefined,
  };
  if (props.showExpInfo) {
    addFunction(params, false);
  }
  emit("add-function", params, false);
}

function callAddUserDefinedVariables(data) {
  if (setValue.value === 0) {
    setValue.value++;
    const params = {
      name: `${data.path}`,
      path: data.path,
      tooltip: data.value,
      inputId: focusInputId.value >= 0 ? focusInputId.value : undefined,
    };
    if (props.showExpInfo) {
      addUserVariable(params, false);
    }
    emit("add-user-variable", params, false);
    setTimeout(() => {
      setValue.value = 0;
    }, 100);
  }
}

function callAddSystemVariables(data, key) {
  if (setValue.value === 0) {
    setValue.value++;
    const params = {
      name: data,
      path: "system-variable",
      tooltip: key,
      inputId: focusInputId.value >= 0 ? focusInputId.value : undefined,
    };
    if (props.showExpInfo) {
      addSystemVariable(params, false);
    }
    emit("add-system-variable", params, false);
    setTimeout(() => {
      setValue.value = 0;
    }, 100);
  }
}

const computedId = computed(() => {
  if (focusId.value) {
    return `${focusId.value}-div-${props.idPrefix}`;
  }
  return "";
});
const focusInputId = ref(-1);
const focusId = ref("");

function setFocusInput(index, id) {
  focusId.value = `${id}-${index}`;
  focusInputId.value = index;
  //   document.getElementById(computedId.value)
  //     .addEventListener("paste", (event) => pasteEvent(event));
}

const storedRange = ref<Range | null>(null);

function onBlur(e: FocusEvent) {
  storedRange.value = saveCaretPosition(e.target as Node);
}

function organizeNodes() {
  try {
    document
      .getElementById(computedId.value)
      .childNodes.forEach((child, index) => {
        const nextChild = document
          .getElementById(computedId.value)
          .childNodes.item(index + 1);
        if (nextChild) {
          if (
            nextChild.nodeType === child.nodeType &&
            child.nodeType !== Node.TEXT_NODE
          ) {
            const zeroWidthSpace = document.createTextNode("\u200B");
            document
              .getElementById(computedId.value)
              .insertBefore(zeroWidthSpace, nextChild);
          } else if (
            nextChild.nodeType === child.nodeType &&
            child.nodeType === Node.TEXT_NODE
          ) {
            if (
              nextChild.textContent === "\u200B" ||
              child.textContent === "\u200B"
            ) {
              document
                .getElementById(computedId.value)
                .removeChild(
                  child.textContent !== "\u200B" ? nextChild : child
                );
            } else {
              child.textContent += nextChild.textContent;
              child.textContent = child.textContent.replace("\u200B", "");
              document.getElementById(computedId.value).removeChild(nextChild);
            }
          }
        }
      });
  } catch (e) {
    console.log(e, "organize");
  }
  convertToInputString();
}

function convertToInputString() {
  try {
    const inputArray = [];
    document
      .getElementById(computedId.value)
      .childNodes.forEach((child: any) => {
        if (child.nodeType === Node.ELEMENT_NODE) {
          inputArray.push({
            name: child.getAttribute("name"),
            origId: child.getAttribute("origId"),
            type: child.getAttribute("type"),
            function: child.getAttribute("function"),
          });
        } else if (
          child.nodeType === Node.TEXT_NODE &&
          child.textContent !== "" &&
          child.textContent !== "\u200B"
        ) {
          inputArray.push({
            name: child.textContent.replaceAll("\u200B", ""),
            type: "input",
          });
        }
      });
    inputArray.forEach((element) => {
      inputs.value[focusInputId.value].value = element;
    });
  } catch (e) {
    console.log(e, "string");
  }
}

function getNextSibling(current?) {
  const elem = document.getElementById(computedId.value);
  const position = getCaretPosition(elem);
  let length = 0;
  let set = false;
  let childIndex = -1;
  elem.childNodes.forEach((child: any, index) => {
    if (child.nodeType === Node.TEXT_NODE) {
      length += child.data.length;
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      length += child.innerText.length;
    }
    if (position <= length && !set && position !== 0) {
      childIndex = index;
      set = true;
    } else if (position === 0) {
      childIndex = -2;
      set = true;
    }
  });
  if (childIndex > -1) {
    return current
      ? {
          item: elem.childNodes.item(childIndex),
          index: childIndex,
        }
      : {
          item: elem.childNodes.item(childIndex + 1),
          index: childIndex + 1,
        };
  }
  if (childIndex === -2) {
    return {
      item: elem.childNodes.item(0),
      index: 0,
    };
  }
  return null;
}

function split(text, index) {
  return [text.slice(0, index), text.slice(index)];
}

function getInputLengthToCaretPosition(index) {
  let length = 0;
  const inputElement = document.getElementById(computedId.value);
  if (!inputElement) {
    return 0;
  }
  inputElement.childNodes.forEach((node: any, idx) => {
    if (node.nodeType === Node.TEXT_NODE && idx < index) {
      length += node.data.length;
    } else if (node.nodeType === Node.ELEMENT_NODE && idx < index) {
      length += node.innerText.length;
    }
  });
  return length;
}

function addItemToInput(span: HTMLSpanElement, first) {
  ensureCaretRestored(computedId.value, storedRange.value);
  const zeroWidthSpace = document.createTextNode("\u200B");
  const current: any = getNextSibling(true);
  const nextNode = getNextSibling();
  if (
    current &&
    current.item.nodeType === Node.TEXT_NODE &&
    current.item.data.length > 1 &&
    !first
  ) {
    const [firstText, second] = split(
      current.item.data,
      getCaretPosition(document.getElementById(computedId.value)) -
        getInputLengthToCaretPosition(current.index)
    );
    const firstElem = current.item;
    firstElem.data = firstText;
    document
      .getElementById(computedId.value)
      .replaceChild(firstElem, current.item);
    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(span, nextNode.item);
    } else {
      document.getElementById(computedId.value).appendChild(span);
    }

    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(document.createTextNode(second), nextNode.item);
    } else {
      document
        .getElementById(computedId.value)
        .appendChild(document.createTextNode(second));
    }
  } else {
    addToDocument(
      span,
      zeroWidthSpace,
      nextNode ? nextNode.item : undefined,
      first
    );
  }
  organizeNodes();
  setCaretPosition(span, computedId.value);
}

function addToDocument(span, zero, next, first) {
  if (next && !first) {
    document.getElementById(computedId.value).insertBefore(span, next);
    document.getElementById(computedId.value).insertBefore(zero, span);
  } else {
    document.getElementById(computedId.value).appendChild(span);
    document.getElementById(computedId.value).appendChild(zero);
  }
}

function addOutput(params, first = false) {
  if (params.stepIndex > -1) {
    const span: HTMLSpanElement = createHTMLSpanElement(
      {
        name: params.name,
        type: "output",
        origId: params.origId,
      },
      false,
      count.value
    );
    count.value++;
    const displayNum =
      typeof params.stepNumber === "number" && params.stepNumber > 0
        ? params.stepNumber
        : params.stepIndex + 1;
    setTagDisplayText(
      span,
      `${displayNum}.${params.path.replaceAll("/#", "/").replaceAll("@#", "/")}`
    );
    addItemToInput(span, first);
  }
}

function addMetaoutput(params, first = false) {
  if (params.stepIndex > -1) {
    const span: HTMLSpanElement = createHTMLSpanElement(
      {
        name: params.name,
        type: "metaoutput",
        origId: params.origId,
      },
      false,
      count.value
    );
    count.value++;
    const displayNum =
      typeof params.stepNumber === "number" && params.stepNumber > 0
        ? params.stepNumber
        : params.stepIndex + 1;
    setTagDisplayText(
      span,
      `${displayNum}.${params.path.replaceAll("/#", "/").replaceAll("@#", "/")}`
    );
    addItemToInput(span, first);
  }
}

function addUserVariable(data, first) {
  const innerText = `.${data.path.replaceAll("/#", "/").replaceAll("@#", "/")}`;
  const span: HTMLSpanElement = createHTMLSpanElement(
    {
      name: `/userDefinedVariables${data.name}`,
      type: "user-defined-variable",
    },
    false,
    count.value,
    innerText
  );
  count.value++;
  setTagDisplayText(span, innerText);
  addItemToInput(span, first);
}

function addSystemVariable(data, first, isNotFirstRender = true) {
  const span: HTMLSpanElement = createHTMLSpanElement(
    {
      name: data.name,
      type: "system-variable",
      tooltip: data.key,
    },
    false,
    count.value,
    data.name
  );
  count.value++;
  setTagDisplayText(
    span,
    data.name
      .split(/(?=[A-Z])/)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ")
  );
  addItemToInput(span, first);
}

function addFunction(item, first) {
  if (!item.hasChild) {
    const span: HTMLSpanElement = createHTMLSpanElement(
      item,
      hasChild(item.type),
      count.value,
      true
    );
    count.value++;
    addItemToInput(span, first);
  } else {
    const span: HTMLSpanElement = createHTMLSpanElement(
      item,
      item.hasChild,
      count.value,
      true
    );
    count.value++;
    addItemToInput(span, first);
    item.childs.forEach((child) => {
      const childSpan: HTMLSpanElement = createHTMLSpanElement(
        child,
        false,
        count.value,
        true
      );
      count.value++;
      childSpan.classList.add(getType(item.type));
      addItemToInput(childSpan, first);
    });
  }
}

function callAddMetaoutput(data) {
  if (
    setValue.value === 0 &&
    isOptionSelectable(selectedMetaoutput.value, "metaoutput") &&
    (selectedMetaoutputId.value !== undefined ||
      selectedMetaoutputId.value > -1)
  ) {
    setValue.value++;
    const params = {
      name: `/${selectedMetaoutputId.value}${data.path}`,
      path: data.path,
      stepIndex: stepIndexMetaoutput.value,
      stepNumber: selectedMetaoutput.value?.stepNumber,
      origId: selectedMetaoutput.value?.origId,
      tooltip: data.value,
      inputId: focusInputId.value >= 0 ? focusInputId.value : undefined,
    };
    if (props.showExpInfo) {
      addMetaoutput(params, false);
    }
    emit("add-metaoutput", params, false);
    setTimeout(() => {
      setValue.value = 0;
    }, 100);
  }
}

function callAddOutput(data) {
  if (
    setValue.value === 0 &&
    isOptionSelectable(selectedOutput.value, "output") &&
    (selectedOutputId.value !== undefined || selectedOutputId.value > -1)
  ) {
    setValue.value++;
    const params = {
      name: `/${selectedOutputId.value}${data.path}`,
      path: data.path,
      stepIndex: stepIndex.value,
      stepNumber: selectedOutput.value?.stepNumber,
      origId: selectedOutput.value?.origId,
      tooltip: data.value,
      inputId: focusInputId.value >= 0 ? focusInputId.value : undefined,
    };
    if (props.showExpInfo) {
      addOutput(params, false);
    }
    emit("add-output", params, false);
    setTimeout(() => {
      setValue.value = 0;
    }, 100);
  }
}

function inputOnChange(val) {
  if (!val.srcElement.innerHTML.includes("</span>")) {
    const params = {
      name: val.srcElement.innerHTML,
      inputId: focusInputId.value >= 0 ? focusInputId.value : undefined,
    };
    console.log("emit add-text", params);
    emit("add-text", params);
  }
}

function onChange(index, type) {
  const items = type === "output" ? props.outputList : props.metaoutputList;
  const item = (items || []).find((option: any) => option?.index === index);

  if (isOptionSelectable(item, type)) {
    if (type === "output") {
      selectedOutputId.value = index;
      userHasSelectedOutput.value = true;
    } else {
      selectedMetaoutputId.value = index;
    }
  }
}

function isValidOutput(step, type): boolean {
  try {
    JSON.stringify(JSON.parse(step[type]));
    return true;
  } catch (e) {
    return false;
  }
}

function findfunctionInfo(name) {
  const namePredicate = (obj) => obj.name === name;

  return (
    textExpressions.value.find(namePredicate) ||
    mathExpressions.value.find(namePredicate) ||
    generalExpressions.value.find(namePredicate) ||
    dateExpressions.value.find(namePredicate) ||
    arrayExpressions.value.find(namePredicate) ||
    encodeDecodeExpressions.value.find(namePredicate) ||
    logicExpressions.value.find(namePredicate) ||
    specialValuesExpressions.value.find(namePredicate) ||
    null
  );
}

async function addToDiv(data, id, index) {
  focusInputId.value = index;
  focusId.value = id;
  try {
    const element = JSON.parse(data);
    const array = [element];
    array.forEach((item) => {
      if (item.type === "output") {
        const normalizedOutput = normalizeOutputReference({
          name: item.name,
          origId: item.origId,
          outputList: props.outputList,
          preferOrigId: preferOrigIdOutputReferences,
        });
        const arr = normalizedOutput.name.split("/#");
        const stepId =
          typeof normalizedOutput.index === "number"
            ? normalizedOutput.index
            : -1;
        addOutput(
          {
            name: normalizedOutput.name,
            path: arr.length >= 2 ? `/#${arr[1]}` : "",
            function: item.function,
            stepIndex: stepId,
            stepNumber: normalizedOutput.stepNumber,
            origId: normalizedOutput.origId ?? item.origId,
          },
          false
        );
      } else if (item.type === "metaoutput") {
        const normalizedMetaoutput = normalizeMetaoutputReference({
          name: item.name,
          origId: item.origId,
          metaoutputList: props.metaoutputList,
          preferOrigId: preferOrigIdOutputReferences,
        });
        const stepId =
          typeof normalizedMetaoutput.index === "number"
            ? normalizedMetaoutput.index
            : -1;
        const lastBit =
          typeof normalizedMetaoutput.name === "string"
            ? normalizedMetaoutput.name.split("@").slice(1).join("@")
            : "";
        const path = lastBit ? `/#${lastBit}` : "/#";
        addMetaoutput(
          {
            name: normalizedMetaoutput.name,
            path,
            function: item.function,
            stepIndex: stepId,
            stepNumber: normalizedMetaoutput.stepNumber,
            origId: normalizedMetaoutput.origId ?? item.origId,
          },
          false
        );
      } else if (item.type === "input") {
        const text = document.createTextNode(item.name);
        document.getElementById(computedId.value).appendChild(text);
      } else if (item.type === "user-defined-variable") {
        const arr = item.name.split("/#");
        const name = arr.length >= 2 ? `/#${arr[1]}` : "";
        addUserVariable(
          {
            name,
            path: name,
          },
          false
        );
      } else if (item.type === "system-variable") {
        addSystemVariable(item, false);
      } else {
        const matchedExpression = props.expressions.find(
          (expression) => expression.name === item.name
        );
        const tooltip = matchedExpression?.hasChild
          ? matchedExpression.description
          : undefined;
        const params = { ...item, tooltip };
        addFunction(params, false);
      }
    });
  } catch (e) {
    console.log(e);
  }
}

function setInputsValue() {
  let variables = [...props.selectedVariables];
  const functionIndex = props.selectedVariables.findIndex(
    (item: any) => item.name === props.functionName
  );
  variables =
    functionIndex !== -1 ? variables.slice(functionIndex + 1) : variables;
  const commaIndices = variables.reduce(
    (indices: any, item: any, index: any) => {
      if (item.name === ",") indices.push(index);
      return indices;
    },
    []
  );
  const variableInputs = [];
  if (commaIndices.length > 0) {
    commaIndices.forEach((commaIndex) => {
      if (commaIndex - 1 >= 0) {
        const prevItem: any = variables[commaIndex - 1];
        if (
          !variableInputs.includes(prevItem) &&
          !prevItem.type.includes("opr")
        ) {
          variableInputs.push(prevItem);
        }
      }
      if (commaIndex + 1 < variables.length) {
        const nextItem: any = variables[commaIndex + 1];
        if (
          !variableInputs.includes(nextItem) &&
          !nextItem.type.includes("opr")
        ) {
          variableInputs.push(nextItem);
        }
      }
    });
  } else {
    variables.forEach((variable: any) => {
      if (!variable.type.includes("opr")) {
        variableInputs.push(variable);
      }
    });
  }

  variableInputs.forEach(async (element, index) => {
    const info = findfunctionInfo(element.name);
    const data = info !== null ? info : element;
    console.log("Set Input Value : ", data);
    await addToDiv(JSON.stringify(data), `definition-${index}`, index);
  });
}
watch(
  () => props.functionName,
  async () => {
    const functionInfo = findfunctionInfo(props.functionName);
    inputs.value = functionInfo !== null ? functionInfo.inputs : [];
    description.value = functionInfo !== null ? functionInfo.description : "";
    await nextTick();
    setInputsValue();
  }
);
onBeforeMount(() => {
  if (
    (!props.outputList || props.outputList.length === 0) &&
    props.showOtherInputs
  ) {
    tab.value = 2;
  } else if (!props.showOtherInputs) {
    tab.value = 4;
  }
});

watch(
  () => props.outputList,
  () => {
    const selectedOutputItem = findItemWithIndex(
      props.outputList,
      selectedOutputId.value
    );

    if (
      hasSelectedIndex(selectedOutputId.value) &&
      !isOptionSelectable(selectedOutputItem, "output")
    ) {
      clearSelectedOutput();
    }

    if (!userHasSelectedTab.value && !userHasSelectedOutput.value) {
      selectDefaultTab();
    } else if (
      tab.value === 1 &&
      (!props.outputList || props.outputList.length === 0)
    ) {
      selectDefaultTab();
    }
  },
  { deep: true }
);

watch(
  () => props.metaoutputList,
  () => {
    const selectedMetaoutputItem = findItemWithIndex(
      props.metaoutputList,
      selectedMetaoutputId.value
    );

    if (
      hasSelectedIndex(selectedMetaoutputId.value) &&
      !isOptionSelectable(selectedMetaoutputItem, "metaoutput")
    ) {
      clearSelectedMetaoutput();
    }

    if (
      tab.value === 5 &&
      (!props.metaoutputList || props.metaoutputList.length === 0)
    ) {
      selectDefaultTab();
    }
  },
  { deep: true }
);

watch(
  () => props.userDefinedVariables,
  () => {
    const hasOutput = props.outputList && props.outputList.length > 0;
    const hasUserDefinedVariables = hasAvailableUserDefinedVariables();

    if (
      !userHasSelectedTab.value ||
      (tab.value === 1 && !hasOutput) ||
      (tab.value === 4 && !hasUserDefinedVariables)
    ) {
      selectDefaultTab();
    }
  },
  { deep: true }
);

const generalExpressions = ref([]);
const mathExpressions = ref([]);
const textExpressions = ref([]);
const dateExpressions = ref([]);
const arrayExpressions = ref([]);
const encodeDecodeExpressions = ref([]);
const logicExpressions = ref([]);
const specialValuesExpressions = ref([]);
const arithmeticOperators = ref([]);
const relationalOperators = ref([]);
const logicalOperators = ref([]);

onMounted(async () => {
  if (Array.isArray(props.expressions)) {
    mathExpressions.value = props.expressions.filter(
      (expr) => expr.type === "math-function"
    );
    textExpressions.value = props.expressions.filter(
      (expr) => expr.type === "text-function"
    );
    generalExpressions.value = props.expressions.filter(
      (expr) => expr.type === "general-function"
    );
    dateExpressions.value = props.expressions.filter(
      (expr) => expr.type === "date-function"
    );
    arrayExpressions.value = props.expressions.filter(
      (expr) => expr.type === "array-function"
    );
    encodeDecodeExpressions.value = props.expressions.filter(
      (expr) => expr.type === "encode-decode-function"
    );
    logicExpressions.value = props.expressions.filter(
      (expr) => expr.type === "logic-function"
    );
    specialValuesExpressions.value = props.expressions.filter(
      (expr) => expr.type === "special-values-function"
    );
    arithmeticOperators.value = props.expressions.filter(
      (expr) => expr.type === "arithmetic-operator"
    );
    relationalOperators.value = props.expressions.filter(
      (expr) => expr.type === "relational-operator"
    );
    logicalOperators.value = props.expressions.filter(
      (expr) => expr.type === "logical-operator"
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(Drawer, {
    "is-open": _ctx.visible,
    speed: 600,
    key: _ctx.drawerKey,
    "max-width": _ctx.showExpInfo ? 600 : 450
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "d-flex h-100",
          id: _ctx.idPrefix + '-popper',
          "data-function-selector-popper": "true"
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("span", { style: {"text-transform":"capitalize"} }, _toDisplayString(_ctx.functionName), 513), [
                  [_vShow, _ctx.functionName]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "card-body p-0 font-size-14 w-100",
              id: 'json-form-component' + _ctx.stepIdx
            }, [
              _createElementVNode("div", {
                id: _ctx.idPrefix + '-popper',
                class: "d-flex flex-column size"
              }, [
                _createElementVNode("div", {
                  class: "p-8-16",
                  id: `definitions-` + _ctx.idPrefix
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputs.value, (input, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: input,
                      class: "d-flex align-items-end justify-content-center gap-2 full-width"
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createTextVNode(_toDisplayString(input.label) + " ", 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("input", {
                            value: input.value,
                            style: {"display":"none"},
                            onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFocused = true)),
                            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = false))
                          }, null, 40, _hoisted_11),
                          _createElementVNode("div", {
                            id: 'definition-' + index + '-div-' + _ctx.idPrefix,
                            contenteditable: "true",
                            class: "form-control root-div",
                            onInput: inputOnChange,
                            onBlur: onBlur,
                            onKeyup: organizeNodes,
                            onClick: ($event: any) => (setFocusInput(index, 'definition')),
                            spellcheck: "false"
                          }, null, 40, _hoisted_12),
                          _hoisted_13
                        ])
                      ])
                    ]))
                  }), 128))
                ], 8, _hoisted_8)
              ], 8, _hoisted_7),
              _withDirectives(_createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)("Common.Description")), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(description.value), 1)
              ], 512), [
                [_vShow, _ctx.showExpInfo]
              ])
            ], 8, _hoisted_6)
          ], 512), [
            [_vShow, _ctx.showExpInfo]
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("ul", _hoisted_19, [
                (_ctx.outputList && _ctx.outputList.length !== 0 && _ctx.mode === 'input')
                  ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link nav-link-func-header", { 'active-func-header': tab.value === 1 }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(1)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "database" })
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showOtherInputs)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link nav-link-func-header func-f", { 'active-func-header': tab.value === 2 }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(2)))
                      }, " f ", 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mode === 'input' && userDefinedVariablesData.value)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link nav-link-func-header func-f", { 'active-func-header': tab.value === 4 }]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(4)))
                      }, " $ ", 2)
                    ]))
                  : _createCommentVNode("", true),
                (
                  _ctx.metaoutputList &&
                  _ctx.metaoutputList.length !== 0 &&
                  _ctx.mode === 'input' &&
                  _ctx.showOtherInputs &&
                  _ctx.showMeta
                )
                  ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link nav-link-func-header", { 'active-func-header': tab.value === 5 }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (changeTab(5)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "info-circle" })
                      ], 2)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              (tab.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(), _createBlock(_unref(ElSelect), {
                        filterable: "",
                        key: _ctx.drawerKey + selectedOutputId.value,
                        "model-value": selectedOutputId.value,
                        onChange: _cache[6] || (_cache[6] = 
                    (index) => {
                      onChange(index, 'output');
                      updatePadding();
                    }
                  ),
                        size: "large",
                        placeholder: "Select a step",
                        id: "step-output-select"
                      }, {
                        prefix: _withCtx(() => [
                          _createElementVNode("span", _hoisted_27, [
                            (selectedOutputId.value !== undefined)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "logo-30",
                                  src: `${_unref(ASSETS_BASE_URL)}/${
                          selectedOutput.value?.connectorSpecId
                        }${_unref(getResolution)(false)}.png`,
                                  alt: "logo"
                                }, null, 8, _hoisted_28))
                              : _createCommentVNode("", true),
                            _createTextVNode("  ")
                          ])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outputList, (output) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: output.index
                            }, [
                              (!isOptionValid(output, 'output'))
                                ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                    key: 0,
                                    class: "box-item",
                                    effect: "custom",
                                    content: "Invalid Output",
                                    placement: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_unref(ElOption), {
                                        key: output.index,
                                        value: output.index,
                                        label: outputLabels.value.get(output.index),
                                        disabled: isOptionDisabled(output)
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(getOptionClass(output, 'output'))
                                          }, [
                                            _createElementVNode("span", _hoisted_29, [
                                              _createElementVNode("img", {
                                                class: "logo-24",
                                                src: `${_unref(ASSETS_BASE_URL)}/${
                                  output.connectorSpecId
                                }${_unref(getResolution)(false)}.png`,
                                                alt: "logo"
                                              }, null, 8, _hoisted_30),
                                              _createTextVNode("  " + _toDisplayString(outputLabels.value.get(output.index)), 1)
                                            ])
                                          ], 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "label", "disabled"]))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (isOptionDisabled(output))
                                  ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                      key: 1,
                                      class: "box-item",
                                      effect: "custom",
                                      content: getSkippedOptionTooltip('output'),
                                      placement: "left"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_unref(ElOption), {
                                          key: output.index,
                                          value: output.index,
                                          label: outputLabels.value.get(output.index),
                                          disabled: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: {"float":"left"},
                                              class: _normalizeClass(getOptionClass(output, 'output'))
                                            }, [
                                              _createElementVNode("img", {
                                                class: "logo-24",
                                                src: `${_unref(ASSETS_BASE_URL)}/${
                                output.connectorSpecId
                              }${_unref(getResolution)(false)}.png`,
                                                alt: "logo"
                                              }, null, 8, _hoisted_31),
                                              _createTextVNode("  " + _toDisplayString(outputLabels.value.get(output.index)), 1)
                                            ], 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "label"]))
                                      ]),
                                      _: 2
                                    }, 1032, ["content"]))
                                  : (_openBlock(), _createBlock(_unref(ElOption), {
                                      key: output.index,
                                      value: output.index,
                                      label: outputLabels.value.get(output.index),
                                      disabled: isOptionDisabled(output)
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          style: {"float":"left"},
                                          class: _normalizeClass(getOptionClass(output, 'output'))
                                        }, [
                                          _createElementVNode("img", {
                                            class: "logo-24",
                                            src: `${_unref(ASSETS_BASE_URL)}/${
                              output.connectorSpecId
                            }${_unref(getResolution)(false)}.png`,
                                            alt: "logo"
                                          }, null, 8, _hoisted_32),
                                          _createTextVNode("  " + _toDisplayString(outputLabels.value.get(output.index)), 1)
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "label", "disabled"]))
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["model-value"])),
                      _createVNode(_unref(ElScrollbar), {
                        class: "margin-top-10",
                        height: '75vh',
                        ref_key: "scrollbar",
                        ref: scrollbar,
                        onScroll: triggerLazyLoad
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_33, [
                            (selectedOutput.value)
                              ? (_openBlock(), _createBlock(JsonTreeView, {
                                  key: 0,
                                  path: _ctx.oldPath,
                                  tab: 1,
                                  onSelected: _cache[7] || (_cache[7] = ($event: any) => (callAddOutput($event))),
                                  data: output.value,
                                  searchable: true,
                                  "search-data": selectedOutput.value?.output,
                                  clickAbleDataType: _ctx.clickAbleDataType
                                }, null, 8, ["path", "data", "search-data", "clickAbleDataType"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 512),
                      _withDirectives(_createElementVNode("div", _hoisted_34, [
                        _createElementVNode("img", {
                          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                          alt: "Loading...",
                          class: "loader-logo-40"
                        }, null, 8, _hoisted_35)
                      ], 512), [
                        [_vShow, loading.value]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (tab.value === 2 && _ctx.showOtherInputs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    (_ctx.mode !== 'function')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_unref(ElInput), {
                              modelValue: searchQuery.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchQuery).value = $event)),
                              placeholder: _unref(t)('Common.SearchAnExpression'),
                              size: "mini",
                              onInput: _unref(onSearchInput)
                            }, null, 8, ["modelValue", "placeholder", "onInput"])
                          ]),
                          (searchQuery.value && searchResults.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("label", null, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.SearchResults")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item) => {
                                    return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                      key: item.name,
                                      content: item.description,
                                      effect: "custom",
                                      placement: "left"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: "tag function-tag",
                                          onClick: ($event: any) => (callAddFunction(item))
                                        }, [
                                          _createVNode(_unref(TagDisplayText), {
                                            text: item.name
                                          }, null, 8, ["text"])
                                        ], 8, _hoisted_41)
                                      ]),
                                      _: 2
                                    }, 1032, ["content"]))
                                  }), 128))
                                ])
                              ]))
                            : (searchQuery.value && searchResults.value.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createElementVNode("label", null, [
                                    _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.NoResultsFound")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(textExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_45)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ]),
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mathExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_48)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ]),
                          _hoisted_49,
                          _createElementVNode("div", _hoisted_50, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_51)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ]),
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logicExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_54)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ]),
                          _hoisted_55,
                          _createElementVNode("div", _hoisted_56, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(encodeDecodeExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_57)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ]),
                          _hoisted_58,
                          _createElementVNode("div", _hoisted_59, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrayExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_60)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ]),
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(generalExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_63)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ]),
                          _hoisted_64,
                          _createElementVNode("div", _hoisted_65, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialValuesExpressions.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTooltip), {
                                key: item.name,
                                content: item.description,
                                effect: "custom",
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "tag function-tag",
                                    onClick: ($event: any) => (callAddFunction(item))
                                  }, [
                                    _createVNode(_unref(TagDisplayText), {
                                      text: item.name
                                    }, null, 8, ["text"])
                                  ], 8, _hoisted_66)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.mode == 'function')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("div", _hoisted_69, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expressionTypes.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTag), {
                                key: item.name,
                                class: "tag exp-step-function-tag clickable-tag",
                                size: "mini",
                                effect: "dark",
                                onClick: ($event: any) => (callAddFunction(item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(TagDisplayText), {
                                    text: item.name
                                  }, null, 8, ["text"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _hoisted_70,
                          _createElementVNode("div", _hoisted_71, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translationOperationTypes.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTag), {
                                key: item.name,
                                class: "tag opr-step-function-tag clickable-tag",
                                size: "mini",
                                effect: "dark",
                                onClick: ($event: any) => (callAddFunction(item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(TagDisplayText), {
                                    text: item.name
                                  }, null, 8, ["text"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _hoisted_72,
                          _createElementVNode("div", _hoisted_73, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translationTypes.value, (item) => {
                              return (_openBlock(), _createBlock(_unref(ElTag), {
                                key: item.name,
                                class: "tag translation-step-function-tag clickable-tag",
                                size: "mini",
                                effect: "dark",
                                onClick: ($event: any) => (callAddFunction(item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(TagDisplayText), {
                                    text: item.name
                                  }, null, 8, ["text"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (tab.value === 4 && userDefinedVariablesData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CustomFields")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(JsonTreeView, {
                        class: "margin-top-10",
                        path: 'oldPath',
                        tab: 4,
                        onSelected: _cache[9] || (_cache[9] = ($event: any) => (callAddUserDefinedVariables($event))),
                        data: userDefinedVariablesData.value,
                        clickAbleDataType: _ctx.clickAbleDataType
                      }, null, 8, ["data", "clickAbleDataType"])
                    ]),
                    (_ctx.showOtherInputs)
                      ? (_openBlock(), _createBlock(_unref(ElDivider), { key: 0 }))
                      : _createCommentVNode("", true),
                    (_ctx.showOtherInputs)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_76, _hoisted_78))
                      : _createCommentVNode("", true),
                    (_ctx.showOtherInputs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemVariables, (value, key, index) => {
                            return (_openBlock(), _createBlock(_unref(ElTooltip), {
                              key: index,
                              tab: 7,
                              class: "tag system-variable-tag",
                              content: value,
                              effect: "custom",
                              placement: "left"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (callAddSystemVariables(key, value))
                                }, [
                                  _createVNode(_unref(TagDisplayText), {
                                    text: _unref(labelConvert)(key)
                                  }, null, 8, ["text"])
                                ], 8, _hoisted_80)
                              ]),
                              _: 2
                            }, 1032, ["content"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (tab.value === 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createVNode(_unref(ElSelect), {
                        filterable: "",
                        "model-value": selectedMetaoutputId.value,
                        onChange: _cache[10] || (_cache[10] = (index) => onChange(index, 'metaoutput')),
                        size: "small",
                        placeholder: "Select a step"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaoutputList, (metaoutput) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: metaoutput.index
                            }, [
                              (!isOptionValid(metaoutput, 'metaoutput'))
                                ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                    key: 0,
                                    class: "box-item",
                                    effect: "custom",
                                    content: "Invalid Metaoutput",
                                    placement: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_unref(ElOption), {
                                        key: metaoutput.index,
                                        value: metaoutput.index,
                                        label: metaoutputLabels.value.get(metaoutput.index),
                                        disabled: isOptionDisabled(metaoutput)
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(getOptionClass(metaoutput, 'metaoutput'))
                                          }, [
                                            _createElementVNode("span", _hoisted_83, [
                                              _createElementVNode("img", {
                                                class: "logo-24",
                                                src: `${_unref(ASSETS_BASE_URL)}/${
                                  metaoutput.connectorSpecId
                                }${_unref(getResolution)(false)}.png`,
                                                alt: "logo"
                                              }, null, 8, _hoisted_84),
                                              _createTextVNode("  " + _toDisplayString(metaoutputLabels.value.get(metaoutput.index)), 1)
                                            ])
                                          ], 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "label", "disabled"]))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (isOptionDisabled(metaoutput))
                                  ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                      key: 1,
                                      class: "box-item",
                                      effect: "custom",
                                      content: getSkippedOptionTooltip('metaoutput'),
                                      placement: "left"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_unref(ElOption), {
                                          key: metaoutput.index,
                                          value: metaoutput.index,
                                          label: metaoutputLabels.value.get(metaoutput.index),
                                          disabled: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: {"float":"left"},
                                              class: _normalizeClass(getOptionClass(metaoutput, 'metaoutput'))
                                            }, [
                                              _createElementVNode("img", {
                                                class: "logo-24",
                                                src: `${_unref(ASSETS_BASE_URL)}/${
                                metaoutput.connectorSpecId
                              }${_unref(getResolution)(false)}.png`,
                                                alt: "logo"
                                              }, null, 8, _hoisted_85),
                                              _createTextVNode("  " + _toDisplayString(metaoutputLabels.value.get(metaoutput.index)), 1)
                                            ], 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "label"]))
                                      ]),
                                      _: 2
                                    }, 1032, ["content"]))
                                  : (_openBlock(), _createBlock(_unref(ElOption), {
                                      key: metaoutput.index,
                                      value: metaoutput.index,
                                      label: metaoutputLabels.value.get(metaoutput.index),
                                      disabled: isOptionDisabled(metaoutput)
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          style: {"float":"left"},
                                          class: _normalizeClass(getOptionClass(metaoutput, 'metaoutput'))
                                        }, [
                                          _createElementVNode("img", {
                                            class: "logo-24",
                                            src: `${_unref(ASSETS_BASE_URL)}/${
                              metaoutput.connectorSpecId
                            }${_unref(getResolution)(false)}.png`,
                                            alt: "logo"
                                          }, null, 8, _hoisted_86),
                                          _createTextVNode("  " + _toDisplayString(metaoutputLabels.value.get(metaoutput.index)), 1)
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "label", "disabled"]))
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["model-value"]),
                      _createVNode(_unref(ElScrollbar), {
                        class: "margin-top-10",
                        height: '75vh',
                        ref_key: "scrollbar",
                        ref: scrollbar,
                        onScroll: triggerLazyLoad
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_87, [
                            (selectedMetaoutput.value)
                              ? (_openBlock(), _createBlock(JsonTreeView, {
                                  key: 0,
                                  path: _ctx.oldPath,
                                  tab: 6,
                                  onSelected: _cache[11] || (_cache[11] = ($event: any) => (callAddMetaoutput($event))),
                                  data: metaoutput.value,
                                  searchable: true,
                                  "search-data": selectedMetaoutput.value?.metaoutput,
                                  clickAbleDataType: _ctx.clickAbleDataType
                                }, null, 8, ["path", "data", "search-data", "clickAbleDataType"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 512),
                      _withDirectives(_createElementVNode("div", _hoisted_88, [
                        _createElementVNode("img", {
                          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                          alt: "Loading...",
                          class: "loader-logo-40"
                        }, null, 8, _hoisted_89)
                      ], 512), [
                        [_vShow, loading.value]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["is-open", "max-width"]))
}
}

})